export default __webpack_public_path__ + "static/IDMC_GRID_2022 Número total de desplazados internos-edd42374956d81e51c9727c37af762c7.jpg";